// Copyright (c) 2024 Cigent Technology Inc. All Rights Reserved.

import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { environment } from '../environments/environment';

interface DeprecationReportBody extends ReportBody {
  sourceFile: string
}

const ReportType = {
  Deprecation: 'deprecation',
  Intervention: 'intervention',
  Crash: 'crash'
}

@Injectable({
  providedIn: 'root'
})
export class CspReportingService {

  startObserving() {
    try {
      const observer = new ReportingObserver((reports, _) => {
        for (const report of reports) {
          if (report?.type === ReportType.Deprecation) {
            environment.__DEV__ && console.log('Report:', report);
            const reportBody = report?.body as DeprecationReportBody;
            if (reportBody?.sourceFile.includes('cigent.com')) {
              let sentryMessage = `report-type: ${report?.type} for ${report?.url} report: ${JSON.stringify(reportBody.toJSON())}`;
              environment.__DEV__ && console.log(sentryMessage);
              Sentry.captureMessage(sentryMessage);
            }
          }

        }
      }, { buffered: true });

      observer.observe();
    }
    catch {
      environment.__DEV__ && console.log('ReportingObserver Not Supported');
    }
  }
}
